import { extractCollection, extractPayload } from '@/utils/dataNormalization';

const extractSnapshotMetrics = (response) => {
  const payload = extractPayload(response);
  const metrics = payload && typeof payload === 'object'
    ? payload.metrics
    : null;

  return metrics && typeof metrics === 'object' ? metrics : {};
};

export const fetchSalesSnapshot = async (salesService, params = {}) => {
  const response = await salesService.index(params);
  const rows = extractCollection(response);

  return {
    rows: Array.isArray(rows) ? rows : [],
    metrics: extractSnapshotMetrics(response),
  };
};

export const fetchSalesRows = async (salesService, params = {}) => {
  const snapshot = await fetchSalesSnapshot(salesService, params);
  return Array.isArray(snapshot?.rows) ? snapshot.rows : [];
};
